var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"control",class:{
      'horizontal': _vm.type === 'horizontal',
      'vertical': _vm.type === 'vertical',
  }},_vm._l((_vm.options),function(option,index){return _c('label',{key:index,class:{'radio': _vm.type === 'horizontal'}},[_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"checked":_vm.value === option.value},on:{"input":() => _vm.$emit('input', option.value)}}),_vm._v(" "+_vm._s(option.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }